module.exports = __webpack_public_path__ + "static/img/100.629022e3.png";